import React from 'react';

export function Arrow() {
  return (
    <svg width="11px" height="11px" viewBox="0 0 11 11" version="1.1">
      <g id="v08" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Afgreiðslustaðir/Útibú-og-afgreiðslur/Hraðbankar"
          transform="translate(-580.000000, -1512.000000)"
          stroke="#1E3D5A"
        >
          <g
            id="Group-14-Copy-3"
            transform="translate(574.000000, 1506.000000)"
          >
            <g id="Combined-Shape" transform="translate(6.000000, 7.000000)">
              <path d="M5.645,0.005 L10.965,4.66 L5.645,9.315 M10.3,4.66 L-3.64153152e-13,4.66"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
